module.exports = __webpack_public_path__ + "static/media/huawei-appgallery-button.3d6b5f65.svg";